import { Component, inject } from '@angular/core';
import { VersionInfoGQL } from '../../../generated/graphql';
import { rxResource } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-server-version-component',
  imports: [MatButtonModule, MatDialogModule],
  standalone: true,
  templateUrl: './server-version-component.html',
  styleUrl: './server-version-component.scss',
})
export class ServerVersionComponent {
  private readonly versionInfoGQL = inject(VersionInfoGQL);

  protected versionInfo = rxResource({
    stream: () => {
      return this.versionInfoGQL.fetch().pipe(map((r) => r.data?.versionInfo));
    },
  });
}
